module.exports = __webpack_public_path__ + "img/food_12.4181a599.jpg";